"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ValueBar = ({ ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledValueBar, {
  role: "presentation",
  ...props
});

ValueBar.propTypes = {
  value: _propTypes.default.number,
  color: _propTypes.default.string,
  height: _propTypes.default.string
};
ValueBar.defaultProps = {
  value: 0,
  color: 'currentColor',
  height: '10px'
};
var _default = ValueBar;
exports.default = _default;